module.exports = __webpack_public_path__ + "resources/img/zoom-ui-customizations-04.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-customizations-04.png
// module id = 1400
// module chunks = 0